<template>
  <el-dialog title="测试" :visible.sync="dialogVisible" width="50%">
    <el-input v-model="liveUrl" placeholder="请输入内容" @change="showLive"></el-input>
    <video style="width: 100%;height: 100%;" ref="videoPlayer" controls></video>
  </el-dialog>
</template>

<script>
import flvjs from 'flv.js';
export default {
  props: {
    parameter: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      liveUrl: "http://10.1.189.66:8080/live?port=1935&app=teach_app&stream=123456_ch0_h",
      dialogVisible: true
    }
  },
  mounted () {
  },
  methods: {
    showLive () {
      // if (this.parameter.liveUrl === '') {
      //   this.$message({
      //     message: '暂无视频',
      //     type: 'warning'
      //   });
      //   return
      // }
      this.dialogVisible = true
      this.initPlayer();
    },
    closeLive () {
      this.dialogVisible = false
    },
    initPlayer () {
      const videoElement = this.$refs.videoPlayer;
      if (flvjs.isSupported()) {
        const flvPlayer = flvjs.createPlayer({
          type: 'flv',
          isLive: true,
          url: this.liveUrl// 替换为你的HTTP-FLV URL
        },
          {
            autoCleanupSourceBuffer: true //自动清除缓存
          });
        flvPlayer.attachMediaElement(videoElement);
        flvPlayer.load();
        flvPlayer.play();
      }
    }
  }
}
</script>

<style></style>